export default "__VITE_PUBLIC_ASSET__342b76da__"